import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {useMemo, useState} from 'react'
import {useProfileImageUrl} from '../../../../Utils/fileUrlHelper'
import {updateNotificationStatus} from '../../../../app/UI/Notifications/core/_requests'
import './styles.css'
import AgentStatusSwitch from '../../../../app/components/AgentStatusSwitch'

const itemClass = 'ms-3 ms-lg-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser, logout} = useAuth()
  const [unviewedCount, setUnviewedCount] = useState<number>(0)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogoutClick = () => {
    if (isLoggingOut) return
    setIsLoggingOut(true)
    logout()
  }
  const profileImageUrl = useProfileImageUrl(currentUser?.result?.profileImage)

  // Get userId from various possible locations
  const getUserId = () => {
    if (currentUser) {
      // Try to get from localStorage directly as fallback
      try {
        const stored = localStorage.getItem('currentUser')
        if (stored) {
          const parsed = JSON.parse(stored)
          return parsed?.result?.userId
        }
      } catch (e) {
        // Ignore parse errors
      }
      return null
    }
  }

  const userId = getUserId()

  const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const UpdateNotifications = () => {
    updateNotificationStatus()
    setUnviewedCount(0)
  }

  const showAgentStatusSwitch = useMemo(() => {
    return (
      currentUser?.result.userType === 'INTERPRETER' &&
      (currentUser?.result.opI_OndemandTelephonic || currentUser?.result.opI_ShdTelephonic)
    )
  }, [currentUser])

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* {showAgentStatusSwitch && (
        <>
          <div className='d-flex align-items-center text-gray-500 fs-6  custom-hide-class'>
            Ad Astra Internal{' '}
          </div>
          <div className={clsx('app-navbar-item', itemClass)}>
            <span
              onClick={() => openInNewTab(`${process.env.REACT_APP_AWS_CONNECT_URL_BUTTTON}`)}
              className='btn btn-success btn-sm fs-6'
            >
              <i className='fa-solid fa-phone me-2'></i>Connect
            </span>
          </div>
          <div className={clsx('app-navbar-item', itemClass)}>
            <AgentStatusSwitch />
          </div>
        </>
      )} */}

      <div className={clsx('app-navbar-item ', itemClass)}>
        <div className='d-flex flex-column me-4 custom-hide-class'>
          <div className='fw-bold d-flex align-items-center fs-7'>
            <span className=''>
              {' '}
              {currentUser?.result.firstName} {currentUser?.result.lastName}{' '}
              {userId && <span> - ID: {userId}</span>}
            </span>
          </div>
          <div className='text-end'>
            <span className='text-gray-600 fw-semibolder fs-8 py-1'>
              {currentUser?.result.role}
            </span>
          </div>
        </div>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div
            className={clsx(
              'cursor-pointer symbol symbol-circle d-flex align-items-center symbol-50px',
              userAvatarClass
            )}
          >
            {profileImageUrl ? (
              <img
                alt='Logo'
                src={profileImageUrl}
                style={{objectFit: 'cover'}}
              />
            ) : (
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/avatars/blank.png')}
                style={{objectFit: 'cover'}}
              />
            )}{' '}
            <a href='#' className='fs-2 fw-bold ms-4 cursor-pointer'>
              <i className='bi bi-chevron-down fa-2x' style={{fontSize: '1rem'}} />
            </a>
          </div>
        </div>

        <HeaderUserMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={btnClass}
          onClick={handleLogoutClick}
          style={{pointerEvents: isLoggingOut ? 'none' : undefined, opacity: isLoggingOut ? 0.7 : 1}}
        >
          <div className='symbol-label fs-2 fw-bold'>
            {isLoggingOut ? (
              <span
                className='spinner-border spinner-border-sm text-primary'
                role='status'
                aria-label='Signing out'
              />
            ) : (
              <i className='bi bi-box-arrow-right fa-3x' style={{fontSize: '1.5rem'}} />
            )}
          </div>
        </div>
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'></div>
      )}
    </div>
  )
}

export {Navbar}
